import { NameValue } from '@infodata-group/inf-commons';
import { Devise } from './devise';
import { Exercise } from './exercise';
import { Journal } from './journal';
import { Country } from './country';
import { VAT } from './vat';
import { Communication } from './communication';

export class AccountParameters {
  public activity: string;
  public addressLand: string;
  public addressLocality: string;
  public addressNum: string;
  public addressPostCode: string;
  public addressRegion: string;
  public addressStreet: string;
  public addressStreet2: string;
  public analytic: number;
  public code: string;
  public communication: Communication[] = [];
  public contact: string;
  public delays: NameValue[] = [];
  public devises: Devise[] = [];
  public exercises: Exercise[] = [];
  public journals: Journal[] = [];
  public label: string;
  public language: string;
  public languages: NameValue[] = [];
  public registrationNumber: string;
  public parities: any[] = [];
  public countries: Country[] = [];
  public rcNum: string;
  public societyType: NameValue = new NameValue('', '');
  public vat: VAT[] = [];
  public taxationOffice: any;
  public title: string;
  public vatId: string;
  public vatCountry: string;
  public accountLength: number;
}
